import React from "react";
import { Box } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ArrowBackIosNewRoundedIcon from "@mui/icons-material/ArrowBackIosNewRounded";
import { useLocation, useNavigate, useParams } from "react-router";
import { useDispatch, useSelector } from "react-redux";

import MenuNavbar from "./MenuNavbar";
import {
  getSettingState,
  setTableModal,
} from "../../../redux/features/settingSlice";
import CustomCircleButton from "../CustomCircleButton";

const HeaderNav = () => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const navigate = useNavigate();
  const params = useParams();
  const location = useLocation();
  const dispatch = useDispatch();
  let urlParams = location.pathname.split("/");
  const { tableModal } = useSelector(getSettingState);

  const handleClickMenu = (e) => {
    e.stopPropagation();
    setAnchorEl(e.currentTarget);
  };

  const handlePrevPage = (e) => {
    e.stopPropagation();

    if (urlParams[6] && urlParams[5] === "topics") {
      // navigate(
      //   `/table/${params.tableId}/${urlParams[3]}/${
      //     urlParams[3] === "opinions" ? params.opinionId : params.discussionId
      //   }`
      // );
      navigate(-1);
      return;
    }
    if (
      urlParams[4] &&
      (urlParams[3] === "opinions" || urlParams[3] === "discussions")
    ) {
      navigate(`/table/${params.tableId}`);
      // navigate(-1);
      // dispatch(setTableModalTab(0));
      // dispatch(setThoughtTab(0));

      return;
    }
    if (urlParams[1] === "profile") {
      navigate(-1);
      return;
    }
    if (urlParams[2] && urlParams[1] === "table") {
      navigate("/");
      return;
    }
    if (urlParams[1] === "about") {
      navigate(-1);
      return;
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        position: "fixed",
        top: "0",
        width: "100%",
        justifyContent: "space-between",
        padding: "8px 16px 0 16px",
        zIndex: 2,
      }}
    >
      <CustomCircleButton
        onClick={(e) => handlePrevPage(e)}
        width='48px'
        height='48px'
        bgColor='white.main'
        color='black.main'
        bShadow='none'
        border='2px solid'
        hoverBgColor='white.main'
        hoverColor='black.main'
        activeBgColor='black.main'
        activeColor='white.main'
      >
        <ArrowBackIosNewRoundedIcon sx={{ fontSize: "32px" }} />
      </CustomCircleButton>
      <Box
        onClick={() => {
          dispatch(setTableModal(!tableModal));
        }}
        sx={{ width: "100%" }}
      ></Box>

      <CustomCircleButton
        onClick={handleClickMenu}
        width='48px'
        height='48px'
        bgColor='white.main'
        color='black.main'
        bShadow='none'
        border='2px solid'
        hoverBgColor='white.main'
        hoverColor='black.main'
        activeBgColor='black.main'
        activeColor='white.main'
      >
        <MoreVertIcon sx={{ fontSize: "32px" }} />
      </CustomCircleButton>

      <MenuNavbar anchorEl={anchorEl} setAnchorEl={setAnchorEl} />
    </Box>
  );
};

export default HeaderNav;
